const round4Decimals = (num) => {
  const factor = 10 ** 4;
  const scaled = Number((num * factor).toPrecision(15));
  return Math.round(scaled) / factor;
};

export default round4Decimals;